import { render, staticRenderFns } from "./HighClassWhiteCollar.vue?vue&type=template&id=020a5052"
import script from "./HighClassWhiteCollar.vue?vue&type=script&lang=js"
export * from "./HighClassWhiteCollar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports